import React from 'react';
import * as S from './styles';

export const EditorTextoExibir = ({ mensagemHtml = '', label, disabled, border = true, color = 'black' }) => {
  const colorList = {
    black: 'var(--texto-color)',
    grey: 'var(--cinza-claro-color)',
    white: 'var(--texto-contraste-color)',
  };
  return (
    <>
      {label && <S.Label>{label}</S.Label>}
      <div
        id="exibirEditorTexto"
        style={{
          marginTop: '10px',
          border: border ? 'solid 2px #0078bb' : '',
          padding: '10px',
          paddingLeft: mensagemHtml.includes('<li>') ? '20px' : '10px',
        }}
        data-testid="PreviewCkEditor"
      >
        <div
          style={{
            width: '100%',
            display: 'block',
            color: colorList[disabled ? 'grey' : color],
          }}
          dangerouslySetInnerHTML={{
            __html: mensagemHtml,
          }}
        />
      </div>
    </>
  );
};

export default EditorTextoExibir;
